import { string, number } from 'prop-types';
import React from 'react';
import useStyles from './BarSegment.styles';
import '../../themeDefaults';

const BarSegment = ({
  color, amount, total
}) => {
  const classes = useStyles({
    color, amount, total
  });
  return (
    <div className={classes.root} />
  );
};

BarSegment.propTypes = {
  /** The color of the BarSegment */
  color: string.isRequired,
  /** The length of the bar is defined as (amount/total)% */
  amount: number.isRequired,
  /** The total the amount is a percentage of */
  total: number
};

BarSegment.defaultProps = {
  total: 100
};

export default BarSegment;
